// extracted by mini-css-extract-plugin
module.exports = {"menu-container":"menu-container_YVgURZ","menuContainer":"menu-container_YVgURZ","notice":"notice_hdUJtg","drop-menu":"drop-menu_ev-Rtb","dropMenu":"drop-menu_ev-Rtb"};